import {
    NewActivityCreationCta,
    NewActivityCreationCtaConfig,
} from '../new-activity-creation-state'

export const ForumCtaEnum = {
    CREATE_THREAD: 'CREATE_THREAD',
    EDIT_THREAD: 'EDIT_THREAD',
    CREATE_TOPIC: 'CREATE_TOPIC',
    EDIT_TOPIC: 'EDIT_TOPIC',
}

// THREAD
export const createThread = () => ({
    left: [],
    right: [
        new NewActivityCreationCta({
            label: 'modals.new.forum.save',
            defaultLabel: 'Save',
            action: ForumCtaEnum.CREATE_THREAD,
            permission: () => true,
        }),
    ],
})

export const editThread = () => ({
    left: [],
    right: [
        new NewActivityCreationCta({
            label: 'modals.new.forum.save',
            defaultLabel: 'Save',
            action: ForumCtaEnum.EDIT_THREAD,
            permission: () => true,
        }),
    ],
})

// TOPIC
export const createTopic = () => {
    return new NewActivityCreationCtaConfig({
        left: [],
        right: [
            new NewActivityCreationCta({
                label: 'modals.new.forum.save',
                defaultLabel: 'Save',
                action: ForumCtaEnum.CREATE_TOPIC,
                permission: () => true,
            }),
        ],
    })
}

export const editTopic = () => ({
    left: [],
    right: [
        new NewActivityCreationCta({
            label: 'modals.new.forum.save',
            defaultLabel: 'Save',
            action: ForumCtaEnum.EDIT_TOPIC,
            permission: () => true,
        }),
    ],
})
